import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  BankAccountModel,
  BankAccountMutationInput,
  BankAccountDeleteInput,
  BankAccountUpdateInput,
} from './model';

export function useCreateBankAccount(
  options?: UseMutationOptions<
    ApiResult<BankAccountModel>,
    ApiError,
    BankAccountMutationInput
  >,
): UseMutationResult<
  ApiResult<BankAccountModel>,
  ApiError,
  BankAccountMutationInput
> {
  return useMutation<
    ApiResult<BankAccountModel>,
    ApiError,
    BankAccountMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'bank-accounts',
      method: 'POST',
      classType: BankAccountModel,
      body,
    });
  }, options);
}

export function useUpdateBankAccount(
  options?: UseMutationOptions<
    ApiResult<BankAccountModel>,
    ApiError,
    BankAccountUpdateInput
  >,
): UseMutationResult<
  ApiResult<BankAccountModel>,
  ApiError,
  BankAccountUpdateInput
> {
  return useMutation<
    ApiResult<BankAccountModel>,
    ApiError,
    BankAccountUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `bank-accounts/${body.bankAccountId}`,
      method: 'PUT',
      classType: BankAccountModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteBankAccount(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    BankAccountDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, BankAccountDeleteInput> {
  return useMutation<{ message: string }, ApiError, BankAccountDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `bank-accounts/${body.bankAccountId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
